import { render, staticRenderFns } from "./Legalization.vue?vue&type=template&id=cc3da0d4&scoped=true&"
import script from "./Legalization.vue?vue&type=script&lang=js&"
export * from "./Legalization.vue?vue&type=script&lang=js&"
import style0 from "./Legalization.vue?vue&type=style&index=0&id=cc3da0d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc3da0d4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
